var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-authorization-container',{attrs:{"page":_vm.page,"require-admin":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Create a new SWAT version")]),_c('p',[_vm._v("Files must be uploaded or placed on the server.")]),_c('admin-swat-version-form',{attrs:{"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }